import {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useCallback,
  Fragment,
  useMemo,
} from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import {
  LayerGroup,
  MapContainer,
  TileLayer,
  useMap,
  useMapEvents,
} from "react-leaflet";
import L from "leaflet";
import "../../../../../componentes/leaflet-migrations";
import "../../../../../componentes/leaflet-fullscreen/Leaflet.fullscreen";
import "leaflet-routing-machine";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import RightBarEasyMaps from "../../../../../componentes/easyMaps/rightBarEasyMaps";
import TitleBarPublic from "../../../../../componentes/easyMaps/titleBarPublic";
import DescriptionBar from "../../../../../componentes/easyMaps/descriptionBar";
import { PolylineCustom } from "../../geolocalizado/leaflatMapa/polyLine";
import ToolBarMapsPublic from "../../../../../componentes/easyMaps/toolbarMapsPublic";
import { useOutletContext, useParams } from "react-router-dom";
import LayerBar from "../../../../../componentes/easyMaps/layerBar";
import { useMapa } from "../../../../../contexts/mapaContext";
import useTextures from "../../geolocalizado/leaflatMapa/hooks/useTextures";

import { scales } from "../../geolocalizado/leaflatMapa/components/drawLine";
import PixiOverlayIcons from "../../geolocalizado/leaflatMapa/pixiOverlayIcons";

dayjs.extend(utc);
dayjs.extend(timezone);

const LeafletMapa = forwardRef((props, ref) => {
  const {
    title,
    setFullScreem,
    fullScreem,
    iconsElements = [],
    boundsCoordinates,
    centerCoordinates = [-10, -48],
    latLngZoomFromUrl,
    collapse,
  } = props;

  const {
    mapId,
    elements,
    connections,
    elementSelected,
    setElementSelected = () => {},
    connectionSelected,
    setConnectionSelected = () => {},
    alertsDataMap,
    configElementDataMap,
    configurationMap,
    connectionsDataMapPercentTraffic,
    connectionsDataMapPercentPower,
    connectionsDataMap,
    startMapRef,
  } = useMapa();

  const [showLabel, setShowLabel] = useState(false);
  const [zoomIcons, setZoomIcons] = useState(5);
  const [contextMenu, setContextMenu] = useState(null);
  const [disableNodes, setDisableNodes] = useState(false);
  const [elementsConnected, setElementsConnected] = useState([]);
  const [openRightBar, setOpenRightBar] = useState(false);
  const [edgeSelected, setEdgeSelected] = useState(null);
  const [openConnection, setOpenConnection] = useState(null);
  const { token } = useParams();
  const { config, configLayer } = useOutletContext();
  const [showLabelEnlace, setShowLabelEnlace] = useState(true);
  const moveTimeout = useRef();
  //lines emakers formated for pixi overlay
  const [markers, setMarkers] = useState([]);
  const [connectionsLine, setConnectionsLine] = useState([]);

  const [disableLinesZoom, setDisableLinesZoom] = useState(false);
  const mapRef = useRef(null);
  const didSetInitialZoom = useRef(false);

  // pega os elementos, conexões e alertas do Map
  const elementsFromMap = useMemo(() => [...elements?.values()], [elements]);
  const connectionsFromMap = useMemo(
    () => [...connections?.values()],
    [connections]
  );
  const alertElementsFromMap = useMemo(
    () => [...alertsDataMap?.values()].flat(),
    [alertsDataMap]
  );
  const theme = useTheme();
  const styles = {
    paperContainer: {
      padding: "16px ",
      display: "flex",
      alignItems: "center",
      position: "relative",
      width: "100%",
      borderRadius: 3,
      mt: 5.5,
    },
    body: {
      width: "100%",
      height: "100%",
      // minWidth: "610px",
      position: "absolute",
      display: "flex",
      flexDirection: "column",
      left: "0px",
      top: "0px",
      //zIndex: 0,
      overflow: "hidden",
    },

    mapInfoStack: {
      padding: "12px 16px",
      width: "250px",
    },
    mapInfoDataStack: {
      padding: "12px 16px",
      width: "120px",
    },
    mapInfoTitle: {
      fontSize: "0.75rem",
      lineHeight: 1.25,
      fontWeight: 600,
      letterSpacing: "0.033em",
      color: "primary.main",
    },
    mapInfoText: {
      fontSize: "0.875rem",
      lineHeight: 1.5,
      fontWeight: 400,
      textTransform: "capitalize",
    },
    fontPopup: {
      margin: "0px",
      fontSize: "10px",
      fontWeight: 500,
      color: theme.palette.color.textEasyMaps,
    },
    titlePopup: {
      margin: "0px",
      fontSize: "12px",
      fontWeight: 500,
      color: theme.palette.color.textEasyMaps,
      width: "100%",
      textAlign: "center",
      marginBottom: "10px",
      whiteSpace: "normal",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: 2, // Limite de 2 linhas
      WebkitBoxOrient: "vertical",
    },
  };

  useEffect(() => {
    // setElementSelected(null);
    setConnectionSelected(null);
    setElementsConnected(null);
    setEdgeSelected(null);
  }, [showLabel]);

  useEffect(() => {
    setTimeout(() => {
      if (mapRef.current && mapRef.current.invalidateSize) {
        mapRef.current.invalidateSize();
      }
    }, 300);
  }, [collapse]);

  function resolveThemePath(theme, path) {
    return path?.split(".").reduce((obj, key) => obj?.[key], theme);
  }

  useEffect(() => {
    const mks = elementsFromMap.map((element) => {
      const configElement = configElementDataMap.get(element.id);

      return {
        ...element,
        position: [
          parseFloat(element?.elementConfig?.config?.coordenadas?.lat),
          parseFloat(element?.elementConfig?.config?.coordenadas?.long),
        ],
        iconId:
          element.img ??
          iconsElements?.find(
            (icon) =>
              icon.nome ==
              (element.tipo === 0
                ? "_roteador"
                : element.tipo === 1
                ? "_mapa"
                : "_pop")
          )?.id, // caso não tenha, recebe o id com base no tipo de elemento
        baseIcon: "marker_circle",
        tint: configElement?.isDown
          ? theme.palette.color?.zabbixSeverty?.disaster
          : resolveThemePath(theme, configElement?.border) ||
            theme.palette.color?.zabbixSeverty.selected,
        severity: configElement?.severity,
        label: element.titulo ?? element.id, // nbsp p/ não quebrar layout
      };
    });
    setMarkers(mks);
  }, [
    elementsFromMap,
    iconsElements,
    alertElementsFromMap,
    configElementDataMap,
  ]);

  useEffect(() => {
    const connections = connectionsFromMap.map((conn) => {
      const positions = formatPoints(conn);
      return {
        id: conn.id,
        variant: configLayer?.[mapId] || "trafego",
        referenceId: conn.referenceId,
        destinationId: conn.destinationId,
        config: {
          animation: conn.config.animation,
          type: conn.config.type,
          capacidade: conn.config.capacidade,
        },
        positions,
      };
    });
    setConnectionsLine(connections);
  }, [connectionsFromMap]);

  const filteredData = useMemo(() => {
    if (!configurationMap || !configLayer) {
      return { markers: markers, enlaces: connectionsLine };
    }
    const isPotencia = configLayer?.[mapId] === "potencia";
    const filtros =
      configurationMap?.configuracoes?.[
        isPotencia ? "camadaPotencia" : "camadaTrafego"
      ]?.filtros;
    if (!filtros || filtros.length === 0) {
      return { markers: markers, enlaces: connectionsLine };
    }

    const dataMap = isPotencia
      ? connectionsDataMapPercentPower
      : connectionsDataMapPercentTraffic;

    // Gera um Set com todos os IDs de conexões filtradas (evita includes O(n))
    const enlacesSelected = new Set(
      filtros?.flatMap((label) => dataMap.get(label) || [])
    );
    //filtras as conexões com base nos filtros
    const enlacesFiltered = connectionsLine.filter((conn) =>
      enlacesSelected.has(conn.id)
    );

    // Filtra conexões relevantes e extrai IDs únicos de markers
    const markersSelectedId = new Set(
      connectionsLine?.flatMap((conn) =>
        enlacesSelected.has(conn.id)
          ? [conn.destinationId, conn.referenceId]
          : []
      )
    );
    // Retorna apenas markers com ID presente
    const filtered = markers.filter((m) => markersSelectedId.has(m.id));

    return { markers: filtered, enlaces: enlacesFiltered };
  }, [
    configurationMap,
    configLayer,
    mapId,
    markers,
    connectionsDataMapPercentPower,
    connectionsDataMapPercentTraffic,
  ]);

  useImperativeHandle(ref, () => ({
    focusZoomExt(id) {
      setElementSelected(elements?.get(id) ?? null);
      focusZoom(id);
    },
  }));

  // -----------------------mapContext-----------------------
  function Events() {
    const map = useMap();
    useMapEvents({
      // click(e) {
      //   onPaneClick(e);
      // },
      zoomanim(e) {
        setDisableLinesZoom(true);
      },
      zoomend(e) {
        setDisableNodes(false);
        setDisableLinesZoom(false);
        setZoomIcons(calculeZoom(map));
      },
      contextmenu(e) {
        L.DomEvent.stopPropagation(e);
      },
      move(e) {
        if (!map) return;
        updateUrl();
      },
    });

    return null;
  }

  const updateUrl = () => {
    if (moveTimeout.current) clearTimeout(moveTimeout.current);
    moveTimeout.current = setTimeout(() => {
      if (!mapRef.current) return;
      const map = mapRef.current;
      const center = map?.getBounds()?.getCenter();
      const zoom = map.getZoom();
      const url = new URL(window?.location?.href);
      url.searchParams.set("lat", center?.lat);
      url.searchParams.set("lng", center?.lng);
      url.searchParams.set("zoom", zoom);
      window.history.replaceState({}, "", url);
    }, 200);
  };

  const SetZoom = () => {
    const map = useMap();
    useEffect(() => {
      if (!map) return;
      setZoomIcons(calculeZoom(map));
    }, [map]);

    return null;
  };

  const SetMaxBounds = () => {
    const map = useMap(); // Acesse o objeto `map`
    useEffect(() => {
      if (!map) return;

      // Define os limites máximos do mapa
      const southWest = L.latLng(-89.98155760646617, -180);
      const northEast = L.latLng(89.99346179538875, 180);
      const bounds = L.latLngBounds(southWest, northEast);

      map.setMaxBounds(bounds);
      map.invalidateSize();
    }, [map]);

    return null;
  };

  const initialOptions = useMemo(() => {
    const urlValid =
      !Number.isNaN(latLngZoomFromUrl.lat) &&
      !Number.isNaN(latLngZoomFromUrl.lng) &&
      !Number.isNaN(latLngZoomFromUrl.zoom);

    if (urlValid) {
      return {
        center: [latLngZoomFromUrl.lat, latLngZoomFromUrl.lng],
        zoom: latLngZoomFromUrl.zoom,
      };
    }
    if (Array.isArray(boundsCoordinates)) {
      return {
        bounds: boundsCoordinates,
        maxZoom: 14,
      };
    }
    return {
      center: [-10, -48], // fallback
      zoom: 4,
    };
  }, [latLngZoomFromUrl, boundsCoordinates]);
  /* ---------- TEXTURAS ---------- */
  const texturesReady = useTextures(iconsElements);
  // ----------------------- fim mapContext-----------------------

  const calculeZoom = (map) => {
    const zoom = map.getZoom();
    const factor = scales[zoom];
    return factor;
  };
  const formatPoints = (element) => {
    let nodeStart = null,
      nodeEnd = null;

    if (element.referenceId == elementSelected?.id) nodeStart = elementSelected;
    else nodeStart = elements?.get(element.referenceId);

    if (element.destinationId == elementSelected?.id) nodeEnd = elementSelected;
    else nodeEnd = elements?.get(element.destinationId);

    let nodeStartPosition = {
      lat: parseFloat(nodeStart?.elementConfig?.config?.coordenadas?.lat),
      long: parseFloat(nodeStart?.elementConfig?.config?.coordenadas?.long),
      active: false,
    };
    let nodeEndPosition = {
      lat: parseFloat(nodeEnd?.elementConfig?.config?.coordenadas?.lat),
      long: parseFloat(nodeEnd?.elementConfig?.config?.coordenadas?.long),
      active: false,
    };

    let points = [
      nodeStartPosition,
      ...(element.positionHandlers ?? []).map((a) => ({
        lat: a.y,
        long: a.x,
        active: false,
      })),
      nodeEndPosition,
    ];

    return points;
  };

  function map_range(value, low1, high1, low2, high2) {
    return parseInt(low2 + ((high2 - low2) * (value - low1)) / (high1 - low1));
  }

  function zoom(action) {
    if (!mapRef.current) return;
    const map = mapRef.current;
    let zoom = map.getZoom();
    // garante que o mapa não fique deslizando
    if (zoom > 17 && action > 0) return;
    if (zoom < 1 && action < 0) return;
    map.setZoom(zoom + action);
  }
  function focusZoom(id) {
    if (!id) return;
    let element = elements?.get(id);
    if (!element) return;
    let cood = element.elementConfig.config.coordenadas;
    focusZoomCoordenates(cood.lat, cood.long);
  }
  function focusZoomCoordenates(lat, lng) {
    const map = mapRef.current;
    setDisableNodes(true);
    setDisableLinesZoom(true);
    map.flyTo([lat, lng], 14);
  }
  const onNodeClick = (event, node) => {
    setConnectionSelected(null);
    const selected = elements?.get(node?.id);
    if (selected?.id === elementSelected?.id) {
      setElementSelected(null);
      return;
    }
    let elementsConnect = [];
    connectionsFromMap.forEach(({ referenceId, destinationId, id }) => {
      if (node?.id === destinationId || node?.id === referenceId) {
        const findElement = elements?.get(
          node?.id === destinationId ? referenceId : destinationId
        );
        elementsConnect.push(findElement);
      }
    });
    setElementSelected(structuredClone(selected));
    setElementsConnected(elementsConnect);
    setOpenRightBar(true);
  };

  const onPaneClick = (e) => {
    // setContextMenu(null);

    if (connectionSelected) setConnectionSelected(null);
    if (edgeSelected) setEdgeSelected(null);
    if (elementsConnected) setElementsConnected(null);
    if (elementSelected) setElementSelected(null);

    if (elementSelected || edgeSelected) {
      setEdgeSelected(null);
      //setConnectionSelected(null);
      setElementSelected(null);
    }
  };
  const onClickLine = useCallback(
    (id) => {
      let connection = connections?.get(id);
      let elemento = elements?.get(connection?.referenceId);
      setElementSelected(elemento);
      setOpenConnection(id);
    },
    [connections, elements]
  );
  // pega o gesto de pinça no mobile, pois esse evento não esta disponivel no wrapper do leaflet-react
  function TouchHandler() {
    const map = useMap();

    useEffect(() => {
      const handleTouchMove = (e) => {
        if (e.touches?.length === 2) {
          setDisableLinesZoom(true);
        }
      };

      const handleTouchEnd = () => {
        setDisableLinesZoom(false);
      };

      // Eventos nativos do Leaflet
      map.getContainer().addEventListener("touchmove", handleTouchMove);
      map.getContainer().addEventListener("touchend", handleTouchEnd);

      return () => {
        map.getContainer().removeEventListener("touchmove", handleTouchMove);
        map.getContainer().removeEventListener("touchend", handleTouchEnd);
      };
    }, [map, setDisableLinesZoom]);

    return null;
  }

  return (
    <>
      <Box sx={{ overflow: "visible", zIndex: 1202 }}>
        <TitleBarPublic
          title={title}
          center={elementSelected != null || connectionSelected != null}
        />
      </Box>
      <Box sx={styles.body}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "100%",
          }}
        >
          <ToolBarMapsPublic
            fullScreem={fullScreem}
            setFullScreem={setFullScreem}
            showLabel={showLabel}
            setShowLabel={setShowLabel}
            setShowLabelEnlace={setShowLabelEnlace}
            showLabelEnlace={showLabelEnlace}
            tipo={0}
          >
            <ToolBarMapsPublic.InputZoomGeo zoom={zoom} />
          </ToolBarMapsPublic>

          <LayerBar elementSelected={elementSelected} mapId={mapId} />

          <DescriptionBar
            elementSelected={elementSelected}
            key={"descrptionbar"}
            variant="default"
            layer={configLayer?.[mapId] || "trafego"}
          />
          {startMapRef.current && (
            <MapContainer
              {...initialOptions}
              maxBoundsViscosity={1}
              key={fullScreem ? `mapaFull` : "mapaSingle"}
              fullscreenControl={false}
              ref={mapRef}
              id="map"
              whenReady={() => updateUrl()}
              minZoom={3}
              maxZoom={19}
              zoomControl={false}
              doubleClickZoom={false}
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                zIndex: 0,
              }}
            >
              <TileLayer
                url={
                  theme.palette.mode == "dark"
                    ? config?.configuracoes?.geo?.mapaTile?.dark ||
                      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    : config?.configuracoes?.geo?.mapaTile?.light ||
                      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                }
                //url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                //url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                //url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                //satelite
                //url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                maxZoom={19}
                attribution="&copy; OpenStreetMap contributors"
              />
              <Events />
              <SetMaxBounds />
              <TouchHandler />

              <SetZoom />
              <LayerGroup>
                {texturesReady && (
                  <PixiOverlayIcons
                    key={"pixiGeoPublic"}
                    markers={filteredData.markers}
                    elementSelected={elementSelected}
                    onClick={onNodeClick}
                    onClickLine={onClickLine}
                    onBackgroundClick={onPaneClick}
                    iconsElements={iconsElements}
                    disable={disableNodes}
                    showLabel={showLabel}
                    connections={filteredData?.enlaces}
                    zoom={zoomIcons}
                    configurationMap={configurationMap}
                    connectionsDataMap={connectionsDataMap}
                    configElementDataMap={configElementDataMap}
                    disableLinesZoom={disableLinesZoom}
                  />
                )}
              </LayerGroup>
            </MapContainer>
          )}

          <RightBarEasyMaps
            mapId={mapId}
            setFocusNodeId={focusZoom}
            open={openRightBar}
            setOpen={setOpenRightBar}
            setElement={setElementSelected}
            setConnections={setElementsConnected}
            iconsElement={iconsElements}
            element={elementSelected?.id ? elementSelected : null}
            fullScreem={fullScreem}
            openConnection={openConnection}
            setOpenConnection={setOpenConnection}
            link={`/easyMaps/mapa/public/${
              elementSelected?.mapRef?.tipo === 0 ? "geo" : "top"
            }/${elementSelected?.mapRefId ?? ""}/${token}`}
          />
        </Box>
      </Box>
    </>
  );
});

export default LeafletMapa;
